module.exports = __webpack_public_path__ + "fonts/ralewaythinitalic.f1d56ee.ttf";